export default __webpack_public_path__ + "static/media/about-me-pic-tablet.a657288b.png";